<footer class="footer-area">
    <div class="container">


    </div>

    <div class="copyright-area">
        <p><a href="http://d-pioneers.com/" target="_blank">Digital Pioneers</a> Powered by </p>
    </div>
</footer>

<div class="go-top"><i class='bx bx-chevron-up'></i></div>
